/* CAPTURE — theme interactions. Loaded once from the Capture header section.
   Every feature checks that its section is on the page, so sections can be
   added, removed or reordered in the theme editor. */
(() => {
  if (window.__capInit) return;
  window.__capInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = document.documentElement;
  root.classList.add('cap-js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const pad = (n, l = 3) => String(n).padStart(l, '0');
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const R = window.capRoutes || { add: '/cart/add', change: '/cart/change', cart: '/cart' };
  const designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- toast ---------- */
  let toastT;
  const toast = msg => {
    const t = $('.cap-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 2600);
  };
  window.capToast = toast;

  /* ---------- shutter intro (home page only) ---------- */
  const shutter = $('.cap-shutter');
  if (shutter) {
    const sc = $('.cap-shutter-count', shutter);
    if (sc && !reduce) {
      const t0 = performance.now();
      const step = t => { const p = Math.min(1, (t - t0) / 820); sc.textContent = pad(Math.max(1, Math.round(p * 100))); if (p < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    }
    setTimeout(() => shutter.remove(), reduce || designMode ? 0 : 1750);
  }

  /* ---------- live clock + frame counter ---------- */
  const tickClock = () => {
    const d = new Date();
    const s = [d.getHours(), d.getMinutes(), d.getSeconds()].map(n => pad(n, 2)).join(':');
    $$('[data-cap-clock]').forEach(c => { c.textContent = s; });
  };
  tickClock(); setInterval(tickClock, 1000);

  let frame = 1, roll = 1, captured = 0, lastFlash = 0;
  const renderFrames = () => {
    $$('[data-cap-frame]').forEach(e => { e.textContent = pad(frame); });
    $$('[data-cap-roll]').forEach(e => { e.textContent = pad(roll, 2); });
    $$('[data-cap-captured]').forEach(e => { e.textContent = captured; });
  };
  renderFrames();

  const cur = $('.cap-cursor');
  const pulse = () => { if (!cur) return; cur.classList.add('snap'); setTimeout(() => cur.classList.remove('snap'), 180); };

  /* click empty space inside a Capture section to "capture the moment" */
  document.addEventListener('click', e => {
    const zone = e.target.closest('[data-cap-zone]');
    if (!zone) return;
    if (e.target.closest('a, button, input, textarea, select, label, form, video, .cap-strip')) return;
    frame++; captured++;
    if (frame > 36) { frame = 1; roll++; }
    renderFrames();
    const flash = $('.cap-flash'); const now = performance.now();
    if (flash && !reduce && now - lastFlash > 400) {
      lastFlash = now; flash.classList.remove('go'); void flash.offsetWidth; flash.classList.add('go');
    }
    pulse();
    toast(`Moment captured · frame ${pad(frame)}`);
  });

  /* ---------- viewfinder cursor ---------- */
  let px = innerWidth / 2, py = innerHeight / 2;
  const box = { x: px - 17, y: py - 17, w: 34, h: 34 };
  let mode = 'free', lockEl = null;
  const cBox = cur && $('.cap-cursor-box', cur), cDot = cur && $('.cap-cursor-dot', cur), cLabel = cur && $('.cap-cursor-label', cur);
  const cursorOn = !!(fine && cur);
  if (cursorOn) {
    root.classList.add('cap-has-cursor');
    addEventListener('pointermove', e => { px = e.clientX; py = e.clientY; cur.classList.add('on'); }, { passive: true });
    document.addEventListener('pointerleave', () => cur.classList.remove('on'));
    document.addEventListener('pointerover', e => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const inter = t.closest('a, button, input, textarea, select, label, summary, [role="button"], [data-cursor]');
      const foc = t.closest('[data-focus]');
      let label = '';
      if (inter && !(foc && inter.contains(foc))) { mode = 'small'; lockEl = null; label = inter.dataset.cursor || ''; }
      else if (foc) { mode = 'lock'; lockEl = foc; label = foc.dataset.focus || 'AF · Lock'; }
      else { mode = 'free'; lockEl = null; }
      cur.classList.toggle('lock', mode === 'lock');
      cLabel.textContent = label;
    });
  }
  const stepCursor = () => {
    let t;
    if (mode === 'lock' && lockEl && lockEl.isConnected) {
      const r = lockEl.getBoundingClientRect();
      t = { x: r.left - 6, y: r.top - 6, w: r.width + 12, h: r.height + 12 };
    } else if (mode === 'small') t = { x: px - 11, y: py - 11, w: 22, h: 22 };
    else t = { x: px - 17, y: py - 17, w: 34, h: 34 };
    if (cur.classList.contains('snap')) { t.x += t.w * .08; t.y += t.h * .08; t.w *= .84; t.h *= .84; }
    const k = reduce ? 1 : .2;
    box.x += (t.x - box.x) * k; box.y += (t.y - box.y) * k; box.w += (t.w - box.w) * k; box.h += (t.h - box.h) * k;
    cBox.style.transform = `translate(${box.x}px, ${box.y}px)`;
    cBox.style.width = box.w + 'px'; cBox.style.height = box.h + 'px';
    cDot.style.transform = `translate(${px}px, ${py}px)`;
    cLabel.style.transform = mode === 'lock'
      ? `translate(${box.x}px, ${Math.max(4, box.y - 16)}px)`
      : `translate(${px + 18}px, ${py + 16}px)`;
  };

  /* ---------- per-section registries (animated in one loop) ---------- */
  const heroes = [], marquees = [], manifestos = [];

  const initHero = scope => $$('.cap-hero', scope).forEach(hero => {
    if (hero.dataset.capReady) return; hero.dataset.capReady = '1';
    const h = { hero, mark: $('.cap-hero-mark', hero), word: $('.cap-hero-word', hero), glow: $('.cap-hero-glow', hero),
      hp: { x: .62, y: .3 }, ht: { x: .62, y: .3 }, last: -1e5 };
    hero.addEventListener('pointermove', e => {
      const r = hero.getBoundingClientRect();
      h.ht.x = (e.clientX - r.left) / r.width; h.ht.y = (e.clientY - r.top) / r.height; h.last = performance.now();
    }, { passive: true });
    heroes.push(h);
  });
  const stepHero = (h, now) => {
    if (!h.hero.isConnected || !h.mark) return;
    const hr = h.hero.getBoundingClientRect();
    if (hr.bottom < 0 || hr.top > innerHeight) return;
    if (now - h.last > 2600) { const a = now / 1900; h.ht.x = .5 + Math.cos(a) * .2; h.ht.y = .34 + Math.sin(a * 1.3) * .16; }
    h.hp.x += (h.ht.x - h.hp.x) * .07; h.hp.y += (h.ht.y - h.hp.y) * .07;
    const lx = hr.left + h.hp.x * hr.width, ly = hr.top + h.hp.y * hr.height;
    const mr = h.mark.getBoundingClientRect();
    h.mark.style.setProperty('--lx', ((lx - mr.left) / mr.width * 100).toFixed(1) + '%');
    h.mark.style.setProperty('--ly', ((ly - mr.top) / mr.height * 100).toFixed(1) + '%');
    h.mark.style.setProperty('--ry', ((h.hp.x - .5) * 18).toFixed(2) + 'deg');
    h.mark.style.setProperty('--rx', (-(h.hp.y - .4) * 14).toFixed(2) + 'deg');
    if (h.word) {
      const wr = h.word.getBoundingClientRect();
      h.word.style.setProperty('--gx', ((lx - wr.left) / wr.width * 100).toFixed(1) + '%');
      h.word.style.setProperty('--gy', ((ly - wr.top) / wr.height * 100).toFixed(1) + '%');
    }
    if (h.glow) { h.glow.style.left = (h.hp.x * 100).toFixed(2) + '%'; h.glow.style.top = (h.hp.y * 100).toFixed(2) + '%'; }
  };

  const initMarquee = scope => $$('.cap-marquee-track', scope).forEach(track => {
    if (track.dataset.capReady) return; track.dataset.capReady = '1';
    marquees.push({ track, x: 0, skew: 0 });
  });
  let lastY = scrollY, vel = 0, dir = 1;
  const stepMarquees = dt => {
    const y = scrollY, dy = y - lastY; lastY = y;
    vel += (dy - vel) * .12;
    if (vel > .6) dir = 1; else if (vel < -.6) dir = -1;
    marquees.forEach(m => {
      if (!m.track.isConnected) return;
      m.x -= dir * (.55 + Math.abs(vel) * .32) * dt / 16.7;
      const half = m.track.scrollWidth / 2;
      if (half > 0) { if (m.x <= -half) m.x += half; if (m.x > 0) m.x -= half; }
      m.skew += (clamp(-vel * .5, -9, 9) - m.skew) * .1;
      m.track.style.transform = `translate3d(${m.x}px, 0, 0) skewX(${m.skew.toFixed(2)}deg)`;
    });
  };

  let last = performance.now();
  const loop = now => {
    const dt = Math.min(64, now - last); last = now;
    if (cursorOn) stepCursor();
    if (!reduce) { heroes.forEach(h => stepHero(h, now)); stepMarquees(dt); }
    requestAnimationFrame(loop);
  };
  requestAnimationFrame(loop);

  /* ---------- small per-section behaviours ---------- */
  const initMagnetic = scope => {
    if (!fine || reduce) return;
    $$('.cap-magnetic', scope).forEach(b => {
      if (b.dataset.capReady) return; b.dataset.capReady = '1';
      b.addEventListener('pointermove', e => {
        const r = b.getBoundingClientRect();
        b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .22}px, ${(e.clientY - r.top - r.height / 2) * .32}px)`;
      });
      b.addEventListener('pointerleave', () => { b.style.transform = ''; });
    });
  };

  const initLoupe = scope => {
    if (!fine) return;
    $$('[data-cap-loupe]', scope).forEach(vf => {
      if (vf.dataset.capReady) return; vf.dataset.capReady = '1';
      const lens = $('.cap-lens', vf); if (!lens) return;
      lens.style.backgroundImage = `url("${vf.dataset.capLoupe}")`;
      vf.addEventListener('pointermove', e => {
        const r = vf.getBoundingClientRect(), z = 2.6, L = lens.offsetWidth / 2;
        const x = e.clientX - r.left, y = e.clientY - r.top;
        lens.style.transform = `translate(${x - L}px, ${y - L}px)`;
        lens.style.backgroundSize = `${r.width * z}px ${r.height * z}px`;
        lens.style.backgroundPosition = `${-(x * z - L)}px ${-(y * z - L)}px`;
        lens.classList.add('on');
      });
      vf.addEventListener('pointerleave', () => lens.classList.remove('on'));
    });
  };

  const io = ('IntersectionObserver' in window && !reduce && !designMode)
    ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.remove('pending'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -10% 0px' })
    : null;
  const initReveal = scope => {
    if (!io) return;
    $$('[data-develop], [data-rise]', scope).forEach(el => {
      if (el.dataset.capReady) return; el.dataset.capReady = '1';
      if (el.getBoundingClientRect().top > innerHeight * .95) { el.classList.add('pending'); io.observe(el); }
    });
  };

  const wrapWords = node => {
    Array.from(node.childNodes).forEach(n => {
      if (n.nodeType === 3) {
        const frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) frag.append(part);
          else { const s = document.createElement('span'); s.className = 'cap-w'; s.textContent = part; frag.append(s); }
        });
        n.replaceWith(frag);
      } else if (n.nodeType === 1) wrapWords(n);
    });
  };
  const initManifesto = scope => $$('.cap-manifesto-text', scope).forEach(mt => {
    if (mt.dataset.capReady) return; mt.dataset.capReady = '1';
    wrapWords(mt);
    const words = $$('.cap-w', mt);
    if (reduce || designMode) words.forEach(w => w.classList.add('lit'));
    manifestos.push({ mt, words });
  });

  const initChips = scope => $$('.cap-chips', scope).forEach(group => {
    if (group.dataset.capReady) return; group.dataset.capReady = '1';
    const section = group.closest('.cap');
    $$('.cap-chip', group).forEach(c => c.addEventListener('click', () => {
      $$('.cap-chip', group).forEach(x => x.setAttribute('aria-pressed', String(x === c)));
      const f = c.dataset.filter;
      $$('.cap-card', section).forEach(k => { k.hidden = !(f === 'all' || k.dataset.cat === f); });
    }));
  });

  const initStrip = scope => $$('.cap-strip', scope).forEach(strip => {
    if (strip.dataset.capReady) return; strip.dataset.capReady = '1';
    let down = false, sx = 0, sl = 0;
    strip.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse') return;
      down = true; sx = e.clientX; sl = strip.scrollLeft; strip.classList.add('dragging');
    });
    addEventListener('pointermove', e => { if (down) strip.scrollLeft = sl - (e.clientX - sx); });
    addEventListener('pointerup', () => { if (!down) return; down = false; strip.classList.remove('dragging'); });
  });

  const initCountdown = scope => $$('.cap-countdown', scope).forEach(cd => {
    if (cd.dataset.capReady) return; cd.dataset.capReady = '1';
    const launch = Date.parse(cd.dataset.launch || '');
    if (isNaN(launch)) return;
    const cell = k => $(`[data-cd="${k}"]`, cd);
    const upd = () => {
      let s = Math.max(0, Math.floor((launch - Date.now()) / 1000));
      const d = Math.floor(s / 86400); s %= 86400;
      const h = Math.floor(s / 3600); s %= 3600;
      const m = Math.floor(s / 60); s %= 60;
      cell('d').textContent = pad(d, 2); cell('h').textContent = pad(h, 2); cell('m').textContent = pad(m, 2); cell('s').textContent = pad(s, 2);
    };
    upd(); setInterval(upd, 1000);
  });

  const initJoin = scope => $$('.cap-join-form', scope).forEach(form => {
    if (form.dataset.capReady) return; form.dataset.capReady = '1';
    const email = $('input[type="email"]', form), err = $('.cap-err[data-client]', form);
    form.addEventListener('submit', e => {
      if (email && (!email.value.trim() || !email.checkValidity())) {
        e.preventDefault();
        if (err) err.hidden = false;
        email.setAttribute('aria-invalid', 'true'); email.focus();
      }
    });
  });

  const initTouchText = scope => { if (!fine) $$('[data-touch-text]', scope).forEach(e => { e.textContent = e.dataset.touchText; }); };

  const initQuickAdd = scope => $$('[data-cap-add]', scope).forEach(b => {
    if (b.dataset.capReady) return; b.dataset.capReady = '1';
    b.addEventListener('click', () => {
      const id = b.dataset.capAdd;
      if (!id) { toast('Choose a collection for this section in the theme editor'); return; }
      addItems([{ id: Number(id), quantity: 1 }], b);
    });
  });

  const initSection = scope => {
    initHero(scope); initMarquee(scope); initMagnetic(scope); initLoupe(scope); initReveal(scope);
    initManifesto(scope); initChips(scope); initStrip(scope); initCountdown(scope); initJoin(scope);
    initTouchText(scope); initQuickAdd(scope);
  };

  /* ---------- header: solid after the top, tucks away on scroll down ---------- */
  const hdr = $('.cap-header-wrap');
  let hy = scrollY;
  const onScroll = () => {
    const y = scrollY;
    if (hdr) {
      hdr.classList.toggle('solid', y > 10);
      if (!root.classList.contains('cap-locked')) {
        if (y > 220 && y > hy + 4) hdr.classList.add('tuck');
        else if (y < hy - 4 || y < 220) hdr.classList.remove('tuck');
      }
    }
    hy = y;
    if (!reduce && !designMode) manifestos.forEach(({ mt, words }) => {
      if (!mt.isConnected) return;
      const r = mt.getBoundingClientRect(), vh = innerHeight;
      const p = clamp((vh * .82 - r.top) / (r.height + vh * .35), 0, 1);
      const n = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('lit', i < n));
    });
  };
  let ticking = false;
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; onScroll(); }); } }, { passive: true });

  /* ---------- mobile menu ---------- */
  const menuBtn = $('.cap-menu-btn'), menu = $('.cap-menu');
  const setMenu = open => {
    if (!menu) return;
    menu.hidden = !open; menuBtn.setAttribute('aria-expanded', String(open));
    menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    root.classList.toggle('cap-locked', open);
    if (open && hdr) hdr.classList.remove('tuck');
  };
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', () => setMenu(menu.hidden));
    $$('a', menu).forEach(a => a.addEventListener('click', () => setMenu(false)));
  }

  /* ---------- bag drawer, wired to the real Shopify cart ---------- */
  const drawer = $('.cap-drawer'), scrim = $('.cap-scrim');
  const list = drawer && $('.cap-bag-list', drawer), empty = drawer && $('.cap-bag-empty', drawer), foot = drawer && $('.cap-bag-foot', drawer);
  let lastFocus = null, closeT;
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat(root.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100); }
    catch (_) { return '$' + (cents / 100).toFixed(2); }
  };
  const sized = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';
  const setCount = n => $$('[data-cap-cart-count]').forEach(e => { e.textContent = n; });
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  const renderCart = cart => {
    setCount(cart.item_count);
    if (!drawer) return;
    list.replaceChildren();
    cart.items.forEach(it => {
      const li = document.createElement('li'); li.className = 'cap-bag-item';
      const img = document.createElement(it.image ? 'img' : 'span');
      img.className = 'cap-bag-thumb';
      if (it.image) { img.src = sized(it.image, 160); img.alt = ''; img.loading = 'lazy'; }
      const meta = document.createElement('div');
      const nm = document.createElement('a'); nm.className = 'cap-bag-name'; nm.href = it.url; nm.textContent = it.product_title;
      const vr = document.createElement('p'); vr.className = 'cap-bag-var'; vr.textContent = it.variant_title || '';
      const q = document.createElement('div'); q.className = 'cap-bag-qty';
      const minus = document.createElement('button'); minus.type = 'button'; minus.className = 'cap-qty-btn'; minus.textContent = '−';
      minus.setAttribute('aria-label', `Decrease quantity of ${it.product_title}`);
      const val = document.createElement('span'); val.className = 'cap-qty-val'; val.textContent = it.quantity;
      const plus = document.createElement('button'); plus.type = 'button'; plus.className = 'cap-qty-btn'; plus.textContent = '+';
      plus.setAttribute('aria-label', `Increase quantity of ${it.product_title}`);
      minus.addEventListener('click', () => changeLine(it.key, it.quantity - 1));
      plus.addEventListener('click', () => changeLine(it.key, it.quantity + 1));
      q.append(minus, val, plus);
      meta.append(nm, vr, q);
      const side = document.createElement('div'); side.className = 'cap-bag-side';
      const pr = document.createElement('span'); pr.className = 'cap-price'; pr.textContent = money(it.final_line_price, cart.currency);
      const rm = document.createElement('button'); rm.type = 'button'; rm.className = 'cap-link-btn'; rm.textContent = 'Remove';
      rm.setAttribute('aria-label', `Remove ${it.product_title}`);
      rm.addEventListener('click', () => changeLine(it.key, 0));
      side.append(pr, rm);
      li.append(img, meta, side); list.append(li);
    });
    const total = $('[data-cap-subtotal]', drawer); if (total) total.textContent = money(cart.total_price, cart.currency);
    empty.hidden = cart.item_count > 0; foot.hidden = cart.item_count === 0;
  };
  const fetchCart = async () => (await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })).json();
  const changeLine = async (key, quantity) => {
    try {
      const r = await fetch(R.change + '.js', { method: 'POST', headers: json, body: JSON.stringify({ id: key, quantity }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || 'Could not update your bag');
      renderCart(d);
    } catch (e) { toast(e.message); }
  };
  const openDrawer = () => {
    if (!drawer) { location.href = R.cart; return; }
    clearTimeout(closeT);
    lastFocus = document.activeElement;
    drawer.hidden = false; scrim.hidden = false;
    requestAnimationFrame(() => { drawer.classList.add('open'); scrim.classList.add('open'); });
    root.classList.add('cap-locked');
    setTimeout(() => { const c = $('.cap-drawer-close', drawer); if (c) c.focus(); }, 60);
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('open'); scrim.classList.remove('open'); root.classList.remove('cap-locked');
    closeT = setTimeout(() => { drawer.hidden = true; scrim.hidden = true; }, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  async function addItems(items, btn, body) {
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    try {
      const r = await fetch(R.add + '.js', body
        ? { method: 'POST', headers: { Accept: 'application/json' }, body }
        : { method: 'POST', headers: json, body: JSON.stringify({ items }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || 'Could not add to your bag');
      renderCart(await fetchCart());
      openDrawer();
    } catch (e) { toast(e.message); }
    finally { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } }
  }
  if (drawer) {
    $$('.cap-bag-btn').forEach(b => b.addEventListener('click', async e => {
      e.preventDefault(); openDrawer();
      try { renderCart(await fetchCart()); } catch (_) {}
    }));
    $('.cap-drawer-close', drawer).addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);
    /* product pages: send the theme's add-to-cart form into this bag instead of the cart page */
    if (drawer.dataset.interceptForms === 'true') {
      document.addEventListener('submit', e => {
        const f = e.target;
        if (!(f instanceof HTMLFormElement) || f.closest('.cap')) return;
        const action = f.getAttribute('action') || '';
        if (!/\/cart\/add(\?|$)/.test(action)) return;
        e.preventDefault(); e.stopImmediatePropagation();
        addItems(null, f.querySelector('[type="submit"]'), new FormData(f));
      }, true);
    }
  }

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden && drawer.classList.contains('open')) closeDrawer();
    else if (menu && !menu.hidden) { setMenu(false); menuBtn.focus(); }
  });

  /* ---------- boot + theme editor support ---------- */
  initSection(document);
  onScroll();
  document.addEventListener('shopify:section:load', e => initSection(e.target));
})();
